import { fetchWithAuth } from '../../../common/utils/apiUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

export const fetchStatuses = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/statuses`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching statuses:', error);
    throw error;
  }
};

export const fetchStatusById = async (id) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/statuses/${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching status by ID:', error);
    throw error;
  }
};

export const createStatus = async (statusData) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/statuses`, {
      method: 'POST',
      body: JSON.stringify(statusData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating status:', error);
    throw error;
  }
};

export const updateStatus = async (id, statusData) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/statuses/${id}`, {
      method: 'PUT',
      body: JSON.stringify(statusData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating status:', error);
    throw error;
  }
};

export const deleteStatus = async (id) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/statuses/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return true;
  } catch (error) {
    console.error('Error deleting status:', error);
    throw error;
  }
};